export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13990.23bdaa47.jpg";